module.exports = __webpack_public_path__ + "f620d533a241f531736f78208a8b84c9.woff2";